import { render, staticRenderFns } from "./IndicatorDropdown.vue?vue&type=template&id=b820eaa0&scoped=true&"
import script from "./IndicatorDropdown.vue?vue&type=script&setup=true&lang=js&"
export * from "./IndicatorDropdown.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./IndicatorDropdown.vue?vue&type=style&index=0&id=b820eaa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b820eaa0",
  null
  
)

export default component.exports